module.exports = __webpack_public_path__ + "img/ic_launcher@3x.8ee65015.png";